export default "__VITE_ASSET__DCQP8oR0__"